// extracted by mini-css-extract-plugin
module.exports = {"LoadingContent":"LoadingContent_LoadingContent__1mNSR","center":"LoadingContent_center__3V7hr","loading_label":"LoadingContent_loading_label__GERSU"};